import type { AxiosInstance } from 'axios';
import { EOneRequestError } from './error';

async function redirectToLogin() {
  const res = await fetch('/home/logout');
  const json = await res.json();
  window.location.href = json?.data ?? '/';
}

// Note: specific errorCodes not to intercept,
// handing over to frontend to judge how to present to user (e.g. modal.alert)
export const errorCodeSetToBypass = new Set(['Process.draft.errorVersion', 'Process.draft.locked']);

export function injectInterceptors(instance: AxiosInstance) {
  // instance
  instance.interceptors.response.use(
    async (response) => {
      const { data, config, request, status } = response;

      // Note: supporting skip interception for specific errorCodes
      if (errorCodeSetToBypass.has(data.errorCode)) {
        return response;
      }
      if (data.success === false) {
        throw new EOneRequestError(data.errorMessage || 'Server error', {
          config,
          status,
          request,
          response,
          errorCode: data.errorCode,
        });
      }
      // case `{"error":"Not logged in","redirect":"/Login"}`
      if (data.error) {
        if (data.redirect) {
          void redirectToLogin();
          return response;
        }
        throw new EOneRequestError(data.error || 'Server error', {
          config,
          status,
          request,
          response,
          errorCode: data.errorCode,
        });
      }

      return response;
    },
    (error) => {
      const { config, request, response, status } = error;
      if (status === 401) {
        void redirectToLogin();
        return response;
      }
      const data = response?.data;
      const msg =
        (typeof data?.errorMessage === 'string' && data.errorMessage) ||
        (typeof data?.error === 'string' && data.error) ||
        response?.statusText ||
        'Server error';

      throw new EOneRequestError(msg, {
        config,
        status,
        request,
        response,
        errorCode: data?.errorCode,
      });
    },
  );
}
